import React from "react";
import Styles from "./EmptySection.module.scss";
import { Text } from "src/components/atoms/Text/Text";
import { GCColor, IconSize } from "src/components/atoms/Icon/icon-prop-types";
import { Icon, IconType } from "src/components/atoms/Icon/Icon";
import { FontSize } from "src/components/types";

interface EmptySectionProps {
  iconType: IconType;
  message: string;
  additionalText?: string;
  size?: FontSize;
  iconSize?: IconSize;
  weight?: string;
  color?: GCColor;
}

export const EmptySection = ({
  iconType,
  message,
  additionalText,
  size = "large",
  weight = "xbold",
  iconSize = "large",
  color = "coolGreyDark",
}: EmptySectionProps) => {
  return (
    <div className={Styles.emptySection}>
      <Icon type={iconType} size={iconSize} fill={"coolGrey"} />
      <Text size={size} weight={weight} color={color}>
        {message}
      </Text>
      {additionalText && (
        <Text size={"small"} color={color} align={"center"}>
          {additionalText}
        </Text>
      )}
    </div>
  );
};
